<!-- Responsibility: Implement dev observability screen behavior for the ui/screens surface.
Scope: Owns ui/screens concerns only; cross-surface orchestration is excluded. -->
<dev-observability-view>
  <div class="menu-overlay">
    <div class="hero">
      <h1>DEV OBSERVABILITY</h1>
      <p>Diagnostics, Telemetry, and Runtime Controls</p>
    </div>

    <div class="menu-section active observability-shell">
      <p class="observability-copy">
        This page centralizes runtime monitoring and diagnostics:
        AI latency/success trends, token/cost estimates, feedback triage queue,
        external reporting health, and offline sync counters.
      </p>
      <button class="action-btn observability-back" onclick={ goBack }>← BACK</button>
      <sys-panel mode="dev"></sys-panel>
    </div>
  </div>

  <script>
    import * as gameStore from '../../game-store.js'
    import { navigateState } from '../../app-states.js'
    import SysPanel from '../panels/sys-panel.riot'

    export default {
      components: { SysPanel },

      goBack() {
        const saveId = gameStore.activeSaveId
        saveId ? navigateState('scene', saveId) : navigateState('hub')
      },
    }
  </script>

  <style>
    .observability-shell {
      max-width: 55rem;
    }

    .observability-copy {
      margin: 0 0 0.9rem;
      color: var(--text-muted);
      font-size: var(--type-sm, 0.875rem);
      line-height: 1.6;
    }

    .observability-back {
      margin-bottom: var(--space-md);
    }
  </style>
</dev-observability-view>
